import { useAuth } from "@clerk/react"

export const MANAGE_ENTERPRISE_SSO_PERMISSION = "org:sys_entconns:manage"

export function canManageEnterpriseSso(
  isLoaded: boolean,
  orgId: string | null | undefined,
  has: ((params: { permission: string }) => boolean) | undefined,
): boolean {
  return Boolean(
    isLoaded &&
    orgId &&
    has?.({
      permission: MANAGE_ENTERPRISE_SSO_PERMISSION,
    }),
  )
}

export function useCanManageEnterpriseSso(): boolean {
  const { has, isLoaded, orgId } = useAuth()

  return canManageEnterpriseSso(isLoaded, orgId, has)
}
